export default {
  SET_CURRENT_SERVICES(state, data) {
    state.currentServices = data;
  },
};
